const objectToQuery = (obj, { getKey = (key) => `query[${key}]` } = {}) =>
  Object.keys(obj).reduce((result, key) => {
    const filterValue = obj[key];
    const queryName = getKey(key);

    if (Array.isArray(filterValue)) {
      result[queryName] = filterValue.map((value) => value?.value ?? value);
    } else if (filterValue instanceof Object) {
      Object.keys(filterValue).forEach((valueKey) => {
        result[`${queryName}_${valueKey}`] = filterValue[valueKey];
      });
    } else {
      result[queryName] = filterValue?.value ?? filterValue;
    }

    return result;
  }, {});

export default objectToQuery;
